import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { forumApi } from '../../api/forum';
import HrnbLoader from '../controls/HrnbLoader';
import HrnbButton from '../controls/HrnbButton';

export default function LatestForumWidget() {
    const navigate = useNavigate();
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let mounted = true;
        const fetch = async () => {
            try {
                const data = await forumApi.listPosts({ size: 5, sortBy: 'createdAt', direction: 'DESC' });
                const list = data?.content || data?.posts || data || [];
                if (mounted) setPosts(Array.isArray(list) ? list.slice(0, 5) : []);
            } catch (err) {
                console.error('[LatestForumWidget]', err.message);
            } finally {
                if (mounted) setLoading(false);
            }
        };
        fetch();
        return () => { mounted = false; };
    }, []);

    const handleNavigate = () => navigate('/forum');

    if (loading) {
        return (
            <div className="main-widget">
                <h3 className="main-widget__title">💬 Свежее на форуме</h3>
                <div className="main-widget__loading">
                    <HrnbLoader size={32} text="Загрузка..." />
                </div>
            </div>
        );
    }

    if (posts.length === 0) {
        return (
            <div className="main-widget">
                <h3 className="main-widget__title">💬 Свежее на форуме</h3>
                <p className="main-widget__empty">Пока нет постов</p>
                <HrnbButton variant="outline" size="sm" onClick={handleNavigate}>
                    💬 На форум
                </HrnbButton>
            </div>
        );
    }

    return (
        <div className="main-widget">
            <h3 className="main-widget__title">💬 Свежее на форуме</h3>
            <div className="main-widget__list">
                {posts.map((post) => (
                    <PostItem key={post.id} post={post} onClick={() => navigate(`/forum/posts/${post.id}`)} />
                ))}
            </div>
            <HrnbButton variant="outline" size="sm" onClick={handleNavigate}>
                💬 Все посты
            </HrnbButton>
        </div>
    );
}

function PostItem({ post, onClick }) {
    const author = typeof post.author === 'string' ? post.author : (post.author?.username || post.author?.name || 'Аноним');
    return (
        <button className="main-widget__item main-widget__item--post" onClick={onClick} type="button">
            <div className="main-widget__item-body">
                <span className="main-widget__item-text">{post.title}</span>
                {post.content && (
                    <p className="main-widget__item-desc">
                        {post.content.length > 100
                            ? `${post.content.substring(0, 100)}...`
                            : post.content}
                    </p>
                )}
                <div className="main-widget__item-meta">
                    <span>{author}</span>
                    {post.createdAt && (
                        <span>{formatDate(post.createdAt)}</span>
                    )}
                    {(post.commentsCount || post.likes) && (
                        <span>
                            💬 {post.commentsCount || 0}  👍 {post.likes || post.likeCount || 0}
                        </span>
                    )}
                </div>
            </div>
        </button>
    );
}

function formatDate(dateStr) {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit' });
}
